import React, { useState, useEffect } from "react";
import {
  Button,
  CircularProgress,
  Grid,
  Paper,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Hidden,
  makeStyles,
  Container,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import { JSONEditor } from "./JSONEditor";
import { PDFViewer } from "./PDFViewer";
import { appUrl } from "../../../../../../../../utils/config";
import { fetchDSBatchDetails } from "../../../../../../containers/actions/common/saslAction";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.5rem",
    backgroundColor: "#f5f9ff",
    width: "100%",
  },
  closeText: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: 500,
    "&:hover": {
      borderBottom: "2px solid red",
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    cursor: "pointer",
    padding: "0.3rem",
  },
  title: {
    fontWeight: 500,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
    },
  },
  subtitle: {
    fontWeight: 500,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
    },
  },
  main: {
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  children: {
    paddingTop: 40,
    // [theme.breakpoints.down('xs')]: {
    //   paddingTop:60,
    // },
  },
}));

const ViewConsumption = (props) => {
  const {
    open,
    onClose,
      schrockenDeliveryScheduleID,
      batchDetails,
    } = props;
    //console.log(batchDetails)
    // const { schrockenDeliveryScheduleBatchID, bomConsumptionAddedIndicator} = batchDetails;
  const classes = useStyles();
    const dispatch = useDispatch();
    //console.log(schrockenDeliveryScheduleID)
  const [jsonData, setjsonData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState("");
    const [error, setError] = useState(null);
    
    useEffect(() => {
        setIsLoading(true)
        axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchBOMConsumptionDetails`,
        {
            schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
            schrockenDeliveryScheduleID: parseInt(
                schrockenDeliveryScheduleID
            ),
            bomConsumptionAddedIndicator: batchDetails?.bomConsumptionAddedIndicator
        }
    )
    .then((res) => {
        setIsLoading(false)
        if (res.data.status) {
            let bomData = res.data.data?.bomConsumptionDetails ? res.data.data?.bomConsumptionDetails : [];
            setjsonData(bomData)
        } else {
            setError("Something went wrong. Please try again later.");
        }
      // console.log(res)
    })
    .catch((err) => {
        setIsLoading(false)
        setError(err.message);
      console.log(err);
    });
    },[])


  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <DialogTitle disableTypography style={{ backgroundColor: "#f5f9ff" }}>
        <Grid container justifyContent="center" className={classes.titleGrid}>
          <Grid item xs={11} sm={11} md={11} className={classes.main}>
            <Typography variant="h4" className={classes.title}>
              View Consumption Details
            </Typography>
          </Grid>

          <Grid item xs={1} sm={1} md={1}>
            <Hidden xsDown implementation="css">
              <Typography
                variant="body2"
                onClick={onClose}
                className={classes.closeText}
              >
                Cancel{" "}
                <CloseIcon
                  fontSize="large"
                  color="error"
                  className={classes.icon}
                />
              </Typography>
            </Hidden>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <Box mt={2}>
          <Grid container spacing={3}>
            {/* Left Panel - COA Data */}
            <Grid item xs={12} md={12}>
              <Paper elevation={3}>
                <Box
                  p={3}
                  display="flex"
                  justifyContent="space-between"
                  borderBottom={1}
                  borderColor="grey.300"
                >
                  <Typography variant="h6">Consumption Details</Typography>
                </Box>
                {error && (
                  <Box
                    style={{
                      border: "2px solid rgb(255,0,0)",
                      backgroundColor: "rgb(255,240,240)",
                      Opacity: 1,
                      textAlign: "center",
                      padding: "0.8rem",
                      fontSize: "0.875rem",
                    }}
                  >
                    <Typography>
                      Something went wrong. Please try again later.
                    </Typography>
                  </Box>
                )}
                <Box p={3}>
                  {isLoading ? (
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <CircularProgress color="primary" />
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ marginTop: 16 }}
                      >
                        {loadingStatus || "Loading..."}
                      </Typography>
                    </Box>
                  ) : (
                    jsonData && (
                        <Container maxWidth="md">
                        {/* {jsonData.map((item, index) => (
                          <Box mb={2} key={index}>
                            <Paper elevation={3} style={{ padding: "16px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                            Material Number:
                                      </Typography> 
                                        <Typography variant="body2" gutterBottom>
                                          {item.BomComponentCode || "N/A"}
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom>
                                    Material Name:
                                      </Typography> 
                                        <Typography variant="body2" gutterBottom>
                                          {item.BomComponentName || "N/A"}
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom>
                                    UOM:
                                      </Typography> 
                                        <Typography variant="body2" gutterBottom>
                                          {item.BomComponentRefUOM || "N/A"}
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom>
                                    Standard Quantity:
                                      </Typography> 
                                        <Typography variant="body2" gutterBottom>
                                          {item.BomComponentRefQuantity || "N/A"}
                                            </Typography>
                            </Paper>
                          </Box>
                        ))} */}
                                                  <pre style={{ fontFamily: "monospace", fontSize: "14px", color: "#333" }}>
        {JSON.stringify(jsonData, null, 2)}
      </pre>
                      </Container>
                    )
                  )}
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ViewConsumption;
